import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  type OnInit,
} from '@angular/core';
import { Column, TableSettings } from '../../table.component';
import { Subscription } from 'rxjs';
import { Filter } from 'src/app/core/services/base/database.service';

@Component({
  selector: 'app-filter-options',
  templateUrl: './filter-options.component.html',
  styleUrls: ['./filter-options.component.scss'],
})
export class FilterOptionsComponent implements OnInit, OnDestroy, OnChanges {
  @Input('column') column!: Column;
  @Input('settings') settings!: TableSettings;
  @Output('columnChanges') columnChanges: EventEmitter<Column> = new EventEmitter();

  currentColumn!: Column;
  value: string | string[] | null = null;

  values: { label: string; value: string }[] = [];

  subscriptions: Subscription[] = [];
  filters: Filter[] = [];

  get multiple(): boolean {
    return !!this.column?.config?.multiple;
  }

  ngOnInit(): void {
    this.loadOptions();
    if (this.column.filters[0]) {
      this.currentColumn = this.column;
      this.value = this.readValue(this.column.filters[0]);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['column'] && changes['column'].currentValue) {
      this.currentColumn = changes['column'].currentValue;
      this.filters = this.currentColumn.filters ?? [];
      this.value = this.readValue(this.filters[0]);
      this.loadOptions();
    }
  }

  private readValue(filter: Filter | undefined): string | string[] | null {
    if (!filter) return this.multiple ? [] : null;
    return (filter.value as string | string[]) ?? (this.multiple ? [] : null);
  }

  private loadOptions(): void {
    const staticOptions: (string | { label: string; value: string })[] =
      this.column?.config?.options ?? [];
    this.values = staticOptions.map((o) =>
      typeof o === 'string' ? { label: o, value: o } : o
    );
  }

  onValueChange(selected: string | string[] | null): void {
    this.value = selected;
    this.applyFilter();
  }

  private applyFilter(): void {
    const isEmpty = this.multiple ? !(this.value as string[])?.length : this.value == null;
    if (isEmpty) {
      this.filters = [];
    } else {
      this.filters = [{
        column: this.column.id,
        operator: this.multiple ? 'in' : 'eq',
        value: this.value,
        visible: true,
      }];
    }
    this.columnChanges.emit({ ...this.currentColumn, filters: this.filters });
  }

  clearFilter(): void {
    this.value = this.multiple ? [] : null;
    this.filters = [];
    this.columnChanges.emit({ ...this.currentColumn, filters: this.filters });
  }

  addFilter(): void {
    this.applyFilter();
  }

  removeFilter(index: number): void {
    this.filters.splice(index, 1);
    this.value = this.multiple ? [] : null;
    this.columnChanges.emit({ ...this.currentColumn, filters: this.filters });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
